import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["service", "unitOfMeasure"];

  declare readonly hasServiceTarget: boolean;
  declare readonly serviceTarget: HTMLInputElement;

  declare readonly hasUnitOfMeasureTarget: boolean;
  declare readonly unitOfMeasureTarget: HTMLSelectElement;

  connect() {
    this.filterUnitOfMeasure({ target: this.serviceTarget });
  }

  filterUnitOfMeasure(event) {
    const serviceCheckbox = event.target;
    const isService = serviceCheckbox.checked;
    const unitOfMeasureSelect = this.unitOfMeasureTarget;
    const options = unitOfMeasureSelect.querySelectorAll("option");

    options.forEach((option) => {
      const isUnitService = option.dataset.isService === "true";
      const shouldBeVisible = isService === isUnitService;

      option.hidden = !shouldBeVisible;

      if (option.selected && !shouldBeVisible) {
        option.selected = false;
      }
    });
  }
}
